import { keyframes } from "@emotion/react"
import styled from "@emotion/styled"
import { Theme, theme } from "@pallet-hq/hegel"

type LoadingIndicatorProps = {
    fullPage?: boolean
}

const LoadingIndicator = (props: LoadingIndicatorProps) => (
    <Wrapper {...props}>
        {[...Array(3)].map((_, index) => (
            <Dot key={index} />
        ))}
    </Wrapper>
)

const loadingAnimation = keyframes`
  0%, 66% {
    transform: scale(1);
  }
  33% {
    transform: scale(1.333);
    opacity: 1;
  }
`

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    ${({ fullPage }: LoadingIndicatorProps) =>
        fullPage &&
        `
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
    `};
`

const Dot = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 100%;
    opacity: 0.6;
    animation: ${loadingAnimation} 1s ease-in-out infinite;
    background-color: ${({ theme }: { theme?: Theme }) =>
        theme?.colors.primary};
    margin: ${theme.space.medium} ${theme.space.xxsmall};

    &:nth-of-type(1) {
        animation-delay: 0s;
    }
    &:nth-of-type(2) {
        animation-delay: 0.18s;
    }
    &:nth-of-type(3) {
        animation-delay: 0.36s;
    }
`

export default LoadingIndicator
